<template>
  <div class="pdt">
    <van-cell title="姓名：" :value="userInfo.fullName" />
    <van-cell title="性别：" :value="userInfo.adminSex" />
    <van-cell title="联系电话：" :value="userInfo.selfPhone" />
    <van-cell title="学生姓名：" :value="userInfo.studentName" class="mgt" />
    <van-cell title="所在校区：" :value="userInfo.campus" />
    <van-cell title="就读年级班级：" :value="userInfo.className" />
  </div>
</template>

<script>
export default {
  data() {
    return {
        userInfo: this.$store.getters.userInfo
    };
  }
};
</script>